import { ptBrCommonFieldsTranslations } from "../common";

export const contact = {
  name: "Contato |||| Contatos",
  fields: {
    uuid: "UUID do Contato",
    name: "Nome",
    email: "E-mail",
    phone: "Telefone",
    phoneNumber: "Número de Telefone",
    avatarUrl: "Avatar",
    lastActivityAt: "Última atividade",
    metadata: "Metadados",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  tabs: {
    details: "Detalhes",
    identities: "Identidades",
    conversations: "Conversas",
  },
  empty: {
    title: "Nenhum contato",
    subtitle: "Ainda não há contatos para exibir.",
  },
  noInfo: "Sem informações de contato",
  unknown: "Desconhecido",
  unknownContact: "Contato Desconhecido",
  merged: "Mesclado",
  lastActivity: "Última atividade",
  details: "Detalhes do contato",
  phone: "Telefone",
  email: "E-mail",
  channel: "Canal",
  customFields: "Campos personalizados",
  neverActive: "Nunca ativo",
  create: {
    title: "Criar Novo Contato",
  },
  edit: {
    title: "Editar Contato: %{name}",
  },
  filters: {
    searchName: "Buscar nome",
    searchEmail: "Buscar e-mail",
  },
  conversations: {
    empty: "Nenhuma conversa encontrada para este contato.",
    conversation: "Conversa",
  },
};

export const contactIdentity = {
  name: "Identidade |||| Identidades",
  fields: {
    externalId: "ID Externo",
    name: "Nome",
    channelType: "Tipo de Canal",
    telegramUserId: "ID de Usuário Telegram",
    telegramGroupId: "ID de Grupo Telegram",
    group: "Grupo",
  },
  externalIdLabels: {
    zapy: "Número WhatsApp",
    telegram: "ID do Telegram",
    telegram_group: "ID do Grupo Telegram",
    email: "Endereço de E-mail",
    default: "ID Externo",
  },
  empty: "Nenhuma identidade vinculada a este contato.",
  verified: "Verificado",
  group: "Grupo",
  individual: "Individual",
};
